/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MinusFifteenSecBackIcon = /*#__PURE__*/ createSvgIcon(
  'MinusFifteenSecBackIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`} fill="currentColor">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M.5 3h1v3.5H5v1H.5V3z"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.909.5A9.5 9.5 0 0119.5 10v.005A9.61 9.61 0 01.512 12l.976-.218A8.61 8.61 0 0018.5 9.997 8.499 8.499 0 009.915 1.5h-.007a8.02 8.02 0 00-7.7 5.648l-.956-.296A9.02 9.02 0 019.91.5z"
            />
            <path d="M7.24 12.37h1.12V7.51H6.33v.94h.91v3.92zM9.39 11.85a3.59 3.59 0 001.9.58c1.19 0 2-.65 2-1.67 0-.87-.75-1.45-1.87-1.45h-.51v-.87H13v-.93H9.8v2.72h1.34c.53 0 .84.24.84.65 0 .41-.31.69-.85.69A1.84 1.84 0 019.84 11l-.45.85z" />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default MinusFifteenSecBackIcon;
